import type { InterviewType } from './interview-scheduling.type';

export enum InterviewInitiationSource {
  MANUAL = 'manual',
  AUTOMATED = 'automated',
}

export interface InterviewSchedulingEvent {
  id: number;
  threadId: number;
  createTs: string;
  updateTs: string;
  recruiterEmail: string;
  recruiterName: string;
  recruiterUserProfileId: number;
  duration: number | null;
  type: InterviewType;
  venueDetails: string | null;
  additionalDetails: string | null;
  schedulingPreferences: string | null;
  requireFinalConfirmation: boolean;
  customMeetingLink: string | null;
  initiationSource: InterviewInitiationSource;
  aiRecruiterName: string | null;
  scheduleDateTs: string | null;
  jobTitle: string;
}
